import { Validator } from "@angular/forms/src/directives/validators";
import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, ValidatorFn } from "@angular/forms";
import { AbstractControl } from "@angular/forms";
import { concat } from "rxjs/operator/concat";

@Directive({
  selector: '[fileInputValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: FileRequiredValidation,
    multi: true
  }]
})


export class FileRequiredValidation implements Validator {
  @Input("fileInputValidator") fileRequired: boolean;
  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.fileRequired ? fileRequiredValidation(this.fileRequired)(control) : null;
  }
}

 export function fileRequiredValidation(required: boolean): ValidatorFn {
   return (control: AbstractControl): { [key: string]: any } | null => {
     if (required && ( control.value==null )) {
      return { 'required': true, 'notValidFileType': false };
    }
        return null;
  };
}

